import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Box } from '../../components/Box/Box';
import { Chips } from '../../components/Chips/Chips';
import { Layout } from '../../components/Layout/Layout';
import { ContentAst } from '../../types/ContentAst';
import { Entity } from '../../types/Entity';
import { MentionedEntity } from '../../types/MentionedEntity';
import { Mentions } from '../../types/Mentions';
import { SharedChipProps } from '../../types/SharedChipProps';
import { Format } from '../TextEditor/format/types';
import { TextEditor } from '../TextEditor/TextEditor';
import { CommentData, MentionEntityType } from './types';

const formats: Format[] = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'ol',
  'ul',
];
interface Props {
  entity: Entity;
  mentions: Mentions;
  isMentionsLoading: boolean;
  resolvedMentions: Mentions;
  onSubmit: (commentData: CommentData) => void;
  content?: ContentAst;
  isFocused?: boolean;
  isSubmitting?: boolean;
  chips?: SharedChipProps[];
  onCancel?: () => void;
  onMentionSearch?: (updatedSearch: string) => void;
  onMention?: (mention: MentionedEntity<MentionEntityType>) => void;
}

export const CommentDraft = ({
  chips,
  content: initialContent = [],
  entity,
  isFocused,
  isMentionsLoading,
  isSubmitting,
  mentions,
  resolvedMentions,
  onMention,
  onCancel,
  onMentionSearch,
  onSubmit,
}: Props) => {
  const intl = useIntl();
  const [content, setContent] = useState<ContentAst>(initialContent);

  const handleSubmitComment = () =>
    onSubmit({
      content,
      mentions: [],
      context: [],
      entity,
    });

  return (
    <Layout direction="column" w="100%">
      {chips?.length && (
        <Box mb={3}>
          <Chips chips={chips} />
        </Box>
      )}
      <TextEditor
        content={content}
        isFocused={isFocused}
        formats={formats}
        isMentionsLoading={isMentionsLoading}
        isPosting={isSubmitting}
        mentions={mentions}
        placeholder={intl.formatMessage({
          id: 'CommentDraft.addCommentPlaceholder',
          defaultMessage: 'Comment or @ to mention',
          description: 'Placeholder for comment input',
        })}
        resolvedMentions={resolvedMentions}
        onMention={onMention}
        onCancel={onCancel}
        onChange={setContent}
        onMentionSearch={onMentionSearch}
        onPost={handleSubmitComment}
      />
    </Layout>
  );
};
